/**
 *
 * @description: 高毅
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'gy';
const comein_channel = isBuild ? 'bc05eea6-40ce-4cbc-92d4-9a1acc36d22f' : '05132548-33b7-46de-a32e-b3d0c913bf38';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'gy';

// 高毅Bridge类 - 使用默认实现
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
